import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import {ViewPromoCodeComponent} from '../view-promo-code/view-promo-code.component';
import { LoaderComponentMasterData } from '../../../shared/component/loader-data/loader.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
     RouterModule.forChild([
             {path : 'viewpromocode', component : ViewPromoCodeComponent}
          ])
  ],
  declarations: [ViewPromoCodeComponent]
})
export class PromoCodeRouteModule { }



// WEBPACK FOOTER //
// ./src/app/section/promocode/promocode-route/promocode-route.module.ts